import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import {
  validatePresence,
  validateLength,
} from 'ember-changeset-validations/validators';

const validation = {
  number: validatePresence({ presence: true, message: "Can't be blank" }),
  exp_month: validateLength({
    min: 1,
    max: 2,
    message: 'Must be between 1 and 12',
  }),
  exp_year: validateLength({ is: 4, message: 'Must be 4 digits' }),
  cvc: validatePresence({ presence: true, message: "Can't be blank" }),
};

export default Route.extend({
  navbarSettings: service(),
  store: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Update Credit Card');
  },

  model() {
    return {
      changeset: new Changeset({}, lookupValidator(validation), validation),
    };
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
